import { Box, Button } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
// import VASArrowIcon from '@/assets/PDP/VASArrowIcon.svg';
import CareProgramVas from '@/assets/vas/CareProgramVas.svg';
import FlexiCancellation from '@/assets/vas/FlexiCancellation.svg';
// import RentToOwn from '@/assets/PDP/RentToOwn.svg';
// import AssuredSellBack from '@/assets/PDP/AssuredSellBack.svg';
import React, { useMemo, useState } from 'react';
import {
	ICartItem,
	TCartValueAddedServices,
} from '@/services/cart/models/cart';
import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import LencoButton from '@/atomic-components/LencoButton';
import StarsBg from './StarsBg';
import { roundPrice } from '@/utils/common';

const vasTypeStarStyleMapping = {
	FURLENCO_CARE_PROGRAM: {
		background: getColor('Minty -5'),
	},
	FLEXI_CANCELLATION: {
		background: getColor('Orange -5'),
	},
};

export const vasTypeIconMap = {
	FURLENCO_CARE_PROGRAM: <CareProgramVas />,
	FLEXI_CANCELLATION: <FlexiCancellation />,
	// FLEX_CANCELLATION: <RentToOwn />,
	// FLEX_CANCELLATION: <AssuredSellBack />,
};

export type TCartVasCardProps = {
	cartType: string;
	cartItems: ICartItem[];
	vasDetails: TCartValueAddedServices;
	onEditClicked: (selectedVas: TCartValueAddedServices) => void;
};

function CartVasCard(props: TCartVasCardProps) {

	const Icon = vasTypeIconMap[props.vasDetails.type];
	const starColor = vasTypeStarStyleMapping[props.vasDetails.type];

	const isSelected = true;

	function vasEditClicked() {
		props.onEditClicked(props.vasDetails as TCartValueAddedServices);
	}

	return (
		<Box sx={{ margin: '16px 0', position: 'relative' }}>
			<FlexBox
				fullWidth
				className={props.vasDetails.type}
				sx={{
					borderRadius: '16px',
					padding: '16px',
					justifyContent: 'space-between',
					gap: 2,
					overflow: 'hidden',
				}}
				onClick={vasEditClicked}
			>
				<Box
					id='VAS_ENTRY_CARD_STARS'
					sx={{ position: 'absolute', left: 0, top: 0, zIndex: 2 }}
				>
					<StarsBg color={starColor.background} />
				</Box>
				<FlexBox fullWidth justifyContent='space-between'>
					<Box>{Icon}</Box>
					<Box sx={{ textAlign: 'left', ml: '8px', width: '100%' }}>
						<FlexBox
							fullWidth
							justifyContent='space-between'
							alignItems={'center'}
						>
							<LencoTypography
								variant='H14_Medium'
								sx={{ color: getColor('Gray 0') }}
							>
								{props.vasDetails.title}
							</LencoTypography>
							<LencoTypography
								variant='Small_SemiBold'
								sx={{
									color: getColor('Gray 0'),
								}}
								mr='4px'
							>
								₹{isSelected ? roundPrice(props.vasDetails.total?.value) : ''}/mo
							</LencoTypography>
						</FlexBox>
						<FlexBox
							fullWidth
							direction='row'
							justifyContent='space-between'
							alignItems='start'
							mt='4px'
						>
							<LencoTypography
								variant='Tiny_Regular'
								sx={{
									textOverflow: 'wrap',
									color: getColor('Gray -1'),
									width: '60%',
								}}
							>
								{!!props.vasDetails.selectedText
									? props.vasDetails.selectedText
									: props.vasDetails.description}
							</LencoTypography>
							<Box width='90px'>
								<LencoButton
									fullWidth
									variant={
										props.vasDetails.cta == 'Add' ? 'contained' : 'outlined'
									}
								>
									<LencoTypography variant='Small_SemiBold'>
										{props.vasDetails.cta}
									</LencoTypography>
								</LencoButton>
							</Box>
						</FlexBox>
					</Box>
				</FlexBox>
			</FlexBox>
		</Box>
	);
}

export default CartVasCard;
